module.exports = __webpack_public_path__ + "static/pic01-2cf8c1a153cfbed093707c632ff57e26.jpg";